import { AppData, navigationSteps } from "../AppDataProvider/AppDataProvider";

import {
  defaultBookingTool,
  organisationWithMapAvailabilityBookingTool,
} from "./bookingTool";

export const defaultAppData: AppData = {
  bookingData: {},
  bookingTool: defaultBookingTool,
  currentStep: "availability",
  steps: navigationSteps,
  toast: [],
};

export const defaultAppDataLocationAvailability: AppData = {
  bookingData: {},
  bookingTool: organisationWithMapAvailabilityBookingTool,
  currentStep: "locationAvailability",
  steps: navigationSteps,
  toast: [],
};
